import React, { useRef, useState } from "react";
import { Play } from "lucide-react";
import Reveal from "./Reveal";

const STEPS = ["Recurso local", "Instalación en contenedor", "Integración en sala de calderas", "Arlan suministra y opera"];

const VideoShowcase = () => {
  const ref = useRef(null);
  const [playing, setPlaying] = useState(false);
  const play = () => { setPlaying(true); ref.current?.play(); };

  return (
    <section id="video" className="bg-1 py-28" data-testid="video-section">
      <div className="max-w-6xl mx-auto px-6 lg:px-12">
        <Reveal className="grid lg:grid-cols-[1fr_auto] gap-8 items-end">
          <div>
            <p className="label">En la práctica</p>
            <h2 className="h-section mt-4">Del recurso al calor en el proceso industrial.</h2>
          </div>
          <p className="text-muted max-w-sm leading-snug">Recorrido completo de una implantación: suministro de biomasa local, instalación junto a la sala de calderas y operación por Arlan.</p>
        </Reveal>

        <Reveal delay={150}>
          <div className="relative mt-12 aspect-video overflow-hidden bg-black border border-line" data-testid="video-frame">
            <video
              ref={ref}
              src="/media/arlan-eaas.mp4"
              poster="/media/arlan-eaas-poster.jpg"
              preload="none"
              playsInline
              controls={playing}
              onPause={(e) => e.target.ended && setPlaying(false)}
              className="w-full h-full object-cover"
              data-testid="eaas-video"
            />
            {!playing && (
              <button onClick={play} className="group absolute inset-0 flex items-center justify-center bg-black/25 hover:bg-black/10 transition-colors" aria-label="Reproducir vídeo" data-testid="video-play-btn">
                <span className="flex items-center gap-3 rounded-full bg-white text-black pl-5 pr-6 py-3.5 text-sm font-semibold tracking-wide group-hover:scale-105 transition-transform">
                  <Play size={18} fill="currentColor" /> Ver vídeo · 2:44
                </span>
              </button>
            )}
          </div>
        </Reveal>

        <div className="mt-8 grid grid-cols-2 md:grid-cols-4 gap-6">
          {STEPS.map((s, i) => (
            <div key={s} className="border-t border-line pt-4" data-testid={`video-step-${i}`}>
              <span className="text-green text-xs tracking-widest">0{i + 1}</span>
              <p className="text-white/80 text-sm mt-2 leading-snug">{s}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default VideoShowcase;
